import { render, staticRenderFns } from "./GameSelector.vue?vue&type=template&id=b8e78eea&"
import script from "./GameSelector.vue?vue&type=script&lang=js&"
export * from "./GameSelector.vue?vue&type=script&lang=js&"
import style0 from "./GameSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports